<template>
  <div v-loading="pageLoading" style="min-height: 150px">
    <no-data v-if="isNoData" />
    <Collapse
      v-for="(flow, index) in flowList"
      :key="index"
      :open="index == 0"
      @change="CollapseChange($event, flow)"
    >
      <div slot="header">
        <div class="headerItem">
          <i class="iconfont iconweiwuliudan" />
          <span style="margin-left: 25px">发货单号: {{ flow.invoiceNumber }}</span>
        </div>
        <div class="headerItem">
          <span style="display: contents">物流单号:</span>
          <span
            style="margin-left: 25px;display: contents;color:#1b73ff;cursor: pointer; "
            @click.stop="lookLogFlow(flow.logisticsNumber, flow.invoiceNumber)"
          >{{ flow.logisticsNumber }}</span>
        </div>
        <div class="headerItem">
          物流状态: {{ flow.deliverState }}
        </div>
      </div>
      <div v-loading="flow.Loading">
        <div class="rj-row" style="padding:10px 10px 0 10px">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                起运地：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.placeDeparture }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                到达地：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.placeArrival }}
              </div>
            </div>
          </div>
          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">期望发货日期：</div>
              <div class="rj-baseinfo__item">{{ flow.carryGoodsDate }}</div>
            </div>
          </div> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.deliverGoodsDate }}
              </div>
            </div>
          </div>
          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">标准承诺配送天数：</div>
              <div class="rj-baseinfo__item">
                {{ flow.distributionDays }} 天
                <el-tooltip class="item" effect="light" content="" placement="top">
                  <div slot="content" style="width:400px;font-size:12px;color:#666666">
                    <span>1、发货规则：仓库接收到发货单后，参照2020年SMB对外发布的最新规则执行</span><br><br>
                    <span>2、时效规则：发货当天不计入时效，隔日0点开始计算物流时效</span><br><br>
                    <span> 3、时效按照“市”进行提报，若地址下沉到“市”级以下的到县、镇、村或较为偏僻的地址需在此时效上面增加1-3天不等</span><br><br>
                    <span>4、若陆运标准时效无法满足客户需求：可通过补差价的方式进行加急（如： 专车等）</span><br><br>
                    <span>5、如遇“双11”、“疫情/交通管制/春运”、“恶劣天气原因”等特殊情况，物流时效均会受到不同程度的影响</span><br>
                  </div>
                  <el-tag>
                    时效说明
                  </el-tag>
                </el-tooltip>
              </div>
            </div>
          </div> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                预计到货日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.expectedDataArrival }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终收货单位：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.destLocationName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收货人：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.consigneeName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终收货地址：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.destAddress }}
              </div>
            </div>
          </div>
          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">物流公司：</div>
              <div class="rj-baseinfo__item">{{ flow.logisticsCompany }}</div>
            </div>
          </div> -->
        </div>
        <div class="rj-row" style="padding: 0 10px">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                备注说明：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.remark }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="flow.fileServerList.length"
          class="rj-row"
          style="padding: 0 10px"
        >
          <div class="rj-col-1">
            <div class="rj-baseinfo" style="height:auto;">
              <div class="rj-baseinfo__label">
                设备签收单：
              </div>
              <div class="rj-baseinfo__item">
                <div style="height: 80px">
                  <div
                    v-for="(file, fileindex) in flow.fileServerList"
                    :key="fileindex"
                    class="qianshouImg"
                  >
                    <img
                      :src="
                        `${token.downloadUrl}/${file.fileServerID}?Token=${token.token}`
                      "
                    >
                  </div>
                  <span class="tip">
                    点击可查看大图
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 境外物流 -->
        <el-divider v-if="intelLogisticsInfo.length!==0" content-position="left">
          国际段物流信息
        </el-divider>
        <div v-for="(item,$index) in intelLogisticsInfo" :key="$index" style="border-bottom: 1px dashed #999999;width: 30%;margin-bottom: 10px;float:left;padding:10px">
          包裹 {{ $index +1 }}
          <div class="rj-row">
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  签收日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ item.deliveryDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  清关日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ item.customsClearanceDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  抵港日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ item.arrivalDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  离境日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ item.departureDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  报关日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ item.customsDeclarationDate || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  到启运港日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ item.atd || "--" }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  提货日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ item.pickUpDate || "--" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row" style="padding: 10px">
          <el-table :data="flow.productList" border style="width: 100%">
            <el-table-column type="index" width="70" label="序号" />
            <el-table-column
              prop="porductCode"
              label="物品代码"
              align="left"
              width="200"
            />
            <el-table-column
              prop="productName"
              label="商品名称"
              align="left"
              width="400"
            />
            <el-table-column prop="number" label="数量" align="left" />
            <el-table-column prop="productUnit" label="单位" align="left" />
            <el-table-column prop="pname" label="是否实物" align="left">
              <template v-slot="{ row }">
                {{
                  row.materialObject == "Y"
                    ? "是"
                    : row.materialObject == "N"
                      ? "否"
                      : ""
                }}
              </template>
            </el-table-column>
            <el-table-column prop="pname" label="查看序列号" align="left">
              <template v-slot="{ row }">
                <lookserial-number
                  :str-contract-code="strContractCode"
                  :product-name="row.salesProductName"
                  :special-product-list="row.specialProduct"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </Collapse>
    <el-dialog
      title="物流跟踪信息"
      :visible.sync="ProcessingVisible"
      width="520px"
      top="15px"
    >
      <div
        v-loading="ProcessingLoading"
        style="max-height: 800px;min-height: 200px;overflow-y: auto"
      >
        <!-- <el-divider content-position="left">境内段物流信息</el-divider>
        <div style="margin: 10px 0" v-if="Processing.logisticCode">
          <span>运单号：{{ Processing.logisticCode }}</span>
        </div>
        <div style="margin-left: 60px">
          <rj-timeline class="Processing">
            <rj-timeline-item
              :color="index != 0 ? '#909399' : ''"
              v-for="(pro, index) in Processing.traces"
              :key="index"
            >
              <p>{{ pro.acceptStation }}</p>
              <p>{{ pro.acceptTime }}</p>
              <div class="itemState" v-if="index == 0">
                {{ $store.state.enumeration.LogisticsStatus[Processing.state] }}
              </div>
            </rj-timeline-item>
          </rj-timeline>
        </div>
        <no-data v-if="!Processing.logisticCode" /> -->
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import lookserialNumber from './lookserialNumber';
import zoom from 'medium-zoom';
import noData from '@/components/noData';
// import timeLine from 'rjelement-components/packages/components/timeLine';
// import timeLineItem from 'rjelement-components/packages/components/timeLineItem';
import { getInterDeliveryDetailsList, getDeliveryDetails, attachmentGetToken } from '@/API';
import { getIntelLogisticsDetailByFhNumNew } from '@/API/international';
export default {
  data () {
    return {
      flowList: [],
      isNoData: false,
      ProcessingVisible: false,
      ProcessingLoading: false,
      Processing: {
        traces: []
      },
      intelLogisticsInfo: [],
      pageLoading: true,
      token: {}
    };
  },
  props: {
    strContractCode: {
      type: String,
      required: true
    }
  },
  components: {
    Collapse,
    noData,
    lookserialNumber
    // 'rj-timeline': timeLine,
    // 'rj-timeline-item': timeLineItem
  },
  computed: {},
  methods: {
    getjtoken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data;
        }
      }).catch(() => {

      });
    },
    iniData () {
      this.pageLoading = true;
      getInterDeliveryDetailsList(this.strContractCode).then((res) => {
        let json = res.data;
        this.pageLoading = false;
        if (json.status === '200') {
          json.data.forEach((item) => {
            item.isLoad = false;
            item.Loading = false;
          });
          this.flowList = json.data;
          this.isNoData = !json.data.length;
        }
      }).catch(() => {
        this.pageLoading = false;
      });
    },
    searchDetail (flow) {
      flow.Loading = true;
      this.lookLogFlow(flow.logisticsNumber, flow.invoiceNumber);
      getDeliveryDetails(this.strContractCode, flow.invoiceNumber, flow.specialProduct).then((res) => {
        flow.Loading = false;
        let json = res.data;
        if (json.status === '200') {
          flow = Object.assign(flow, json.data);
          flow.isLoad = true;
          this.$nextTick(() => {
            this.zoomImg();
          });
        }
      }).catch(() => {
        flow.Loading = false;
      });
    },
    zoomImg () {
      setTimeout(() => {
        zoom('img');
      }, 200);
    },
    CollapseChange (val, flow) {
      if (val && !flow.isLoad) {
        this.searchDetail(flow);
      }
    },
    lookLogFlow (val, invoiceNumber) {
      if (val) {
        this.Processing = {
          traces: []
        };
        // this.ProcessingVisible = true;
        // this.ProcessingLoading = true;
        // getLogisticsInfoToList(val).then((res) => {
        //   let json = res.data;
        //   this.ProcessingLoading = false;
        //   if (json.status === '200') {
        //     console.log(json.data);
        //     this.Processing = json.data;
        //   }
        // }).catch(() => {
        //   this.ProcessingLoading = false;
        // });
      }
      if (invoiceNumber) {
        this.intelLogisticsInfo = [];
        getIntelLogisticsDetailByFhNumNew(invoiceNumber).then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data !== null) {
            this.intelLogisticsInfo = json.data;
          }
        }).catch(() => {
          this.ProcessingLoading = false;
        });
      }
    }
  },
  mounted () {
    this.zoomImg();
    this.getjtoken();
    this.iniData();
  },
  updated () {
    // this.zoomImg();
  }
};
</script>
<style lang="scss" scoped>
@import "../../../style/var";

.headerItem {
  float: left;
  margin-right: 40px;
  font-size: 15px;
  :first-child {
    position: absolute;
    top: 14px;
  }
  &:last-child {
    margin-right: 0;
  }
  i {
    font-size: 20px;
    color: $primaryColor;
    margin-right: 5px;
  }
}
.headerItem::after {
  content: "";
  clear: both;
  display: block;
  width: 0;
  height: 0;
  visibility: hidden;
}
.qianshouImg {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  margin: 0 5px;
  float: left;
  overflow: hidden;
  img {
    width: 100%;
  }
}
.tip {
  @include tipText;
  vertical-align: bottom;
  line-height: 80px;
}
</style>
<style lang="scss">
@import "../../../style/var";
.Processing {
  p {
    margin-bottom: 6px;
  }
  .itemState {
    position: absolute;
    left: -60px;
    top: 2px;
  }
  .rj-timeline-item__tail {
    top: 6px;
  }
  .rj-timeline-item {
    padding: 0 0 5px;
    .rj-timeline-item__content {
      color: $--color-text-secondary;
    }
    &:first-child {
      .rj-timeline-item__content {
        color: $--color-primary;
      }
    }
  }
}
</style>
